import React from 'react';

type Props = {
    shared?: boolean;
    size: number;
    color: string;
};

// Inline twins of assets/dir2.svg and assets/dirshare.svg: the paths come
// from there, the fill comes from the theme instead of being baked in.
const PLAIN_FOLDER_PATH =
    'm1.5 2c-0.25 0-0.5 0.25-0.5 0.5v11c0 0.26 0.24 0.5 0.5 0.5h13c0.26 0 0.5-0.241 0.5-0.5v-9c0-0.25-0.25-0.5-0.5-0.5h-6.5l-2-2z';

const SHARED_FOLDER_PATH =
    'M1.46 2c-.25 0-.46.21-.46.46v11.08c0 .257.203.46.46.46h13.08c.257 0 .46-.203.46-.46V4.462a.47.47 0 0 0-.46-.465H8L6 2H1.46zm7.583 3.82c.671 0 1.24.49 1.24 1.123v.014c-.007.197-.007.424-.142.969l-.012.011a.914.914 0 0 1-.156.26c-.067.086-.145.173-.22.258l-.089.104c-.013.05-.03.104-.039.154-.038.187-.019.308 0 .35.333.141.668.267.955.388.314.133.584.264.764.479a.208.208 0 0 1 .05.103c.02.155.036.417.053.684.017.267.035.54.051.66a.212.212 0 0 1-.103.207c-.566.301-1.457.434-2.352.437-.895.004-1.793-.121-2.377-.437a.212.212 0 0 1-.104-.207c.022-.171.044-.385.069-.598l-.022.002c-.614.003-1.23-.084-1.63-.3a.146.146 0 0 1-.07-.143c.033-.264.076-.656.105-.922a.111.111 0 0 1 0-.018c.03-.129.12-.173.213-.23.091-.057.204-.105.328-.158.22-.096.466-.179.664-.248a.69.69 0 0 0-.018-.248l-.035-.153-.018-.017a3.558 3.558 0 0 1-.168-.186c-.05-.059-.088-.102-.115-.178l-.01-.007v-.01a3.08 3.08 0 0 1-.097-.664c0-.435.391-.772.851-.772.46 0 .852.337.852.772v.01c-.005.135-.005.29-.098.664l-.01.01a.61.61 0 0 1-.105.175c-.045.059-.1.12-.15.178l-.063.07c-.009.036-.02.074-.027.108a.448.448 0 0 0 0 .238c.228.097.46.183.656.266.15.063.277.134.387.216.144-.051.297-.114.424-.158a1.03 1.03 0 0 0-.026-.361c-.015-.07-.036-.149-.053-.22l-.025-.026a5.503 5.503 0 0 1-.246-.272c-.074-.085-.13-.148-.168-.258l-.012-.013v-.014c-.12-.522-.138-.768-.142-.969 0-.633.569-1.123 1.24-1.123z';

export const FolderIcon = ({ shared, size, color }: Props): JSX.Element => (
    <svg
        viewBox="0 0 16 16"
        width={size}
        height={size}
        fill={color}
        aria-hidden="true"
        style={{ flexShrink: 0 }}
    >
        {shared ? (
            <path fillRule="evenodd" d={SHARED_FOLDER_PATH} />
        ) : (
            <path d={PLAIN_FOLDER_PATH} />
        )}
    </svg>
);
